



import { Component, Vue } from 'vue-property-decorator'
import UserModule from '@api/module/customer/user/UserModule'

@Component
export default class extends Vue {
  async created() {
    this.$authentication.thirdParty.setWxloginToken(this.$route.query.token as any)
    if (this.$route.query.connectState === '1') {
      // await UserModule.isLogin()
      if (!UserModule.isLogin) {
        await this.$authentication.wxTokenLogin(this.$route.query.token as any)
        window.opener.loginSuccess()
      } else {
        await this.$alert('该微信已关联其他帐号，如需更换请先进行解绑。', '温馨提示')
      }
    } else if (this.$route.query.connectState === '2') {
      let isAppExists = false
      if (this.$route.query.token) {
        const res = await UserModule.haveBindWXByTokenForOpenAPI(this.$route.query.token as string)
        isAppExists = res.data
      }
      console.log(isAppExists)
      // 如果小程序已经注册
      if (isAppExists) {
        await this.$authentication.wxTokenLogin(this.$route.query.token as string)
        window.opener.loginSuccess()
        return window.close()
      }
      if (!UserModule.isLogin) {
        await window.opener.openBidingDialog()
      } else {
        await window.opener.bindWeixin()
      }
    }
    window.close()
  }
}
